import { render, staticRenderFns } from "./InputNumber.vue?vue&type=template&id=83bb9a84&"
import script from "./InputNumber.vue?vue&type=script&lang=ts&"
export * from "./InputNumber.vue?vue&type=script&lang=ts&"
import style0 from "./InputNumber.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports